import React from 'react';

import {MainLayout} from 'widgets/layout';
import {Reports} from 'features/admin';

const AdminReportsPage: React.FC = () => {

    return (
        <MainLayout>
            <Reports />
        </MainLayout>
    );
};

export default AdminReportsPage;